__turbopack_context__.v({
  "block": "NC-NNa_block",
  "blue": "NC-NNa_blue",
  "button": "NC-NNa_button",
  "default": "NC-NNa_default",
  "gray": "NC-NNa_gray",
  "pink": "NC-NNa_pink",
  "secondary": "NC-NNa_secondary",
  "simple-text": "NC-NNa_simple-text",
  "size-full": "NC-NNa_size-full",
  "size-lg": "NC-NNa_size-lg",
  "size-md": "NC-NNa_size-md",
  "size-sm": "NC-NNa_size-sm",
  "yellow": "NC-NNa_yellow",
});
